import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Survey from "@pages/Survey";
import ThankYou from "@pages/ThankYou";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { I18nProvider } from "@lingui/react";
import { i18n } from "@lingui/core";
import { defaultLocale, dynamicActivate } from "@utils/i18n";
import { usePersistentSurveyStore } from "@store/survey";
import "./App.css";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://bce4aa55e7634496aa37fe99df7cbb1b@o4506839635853312.ingest.us.sentry.io/4508310347579392",
  integrations: [],
});

function App() {
  const userUUID = usePersistentSurveyStore().getUserUUID();
  const setUserUUID = usePersistentSurveyStore((state) => state.setUserUUID);
  const language = usePersistentSurveyStore().getLanguage();

  useEffect(() => {
    dynamicActivate(language || defaultLocale);
  }, [language]);

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 3,
        retryDelay: (attemptIndex) => Math.min(250 * 2 ** attemptIndex, 30000),
      },
      mutations: {
        retry: 3,
        retryDelay: (attemptIndex) => Math.min(250 * 2 ** attemptIndex, 30000),
      },
    },
  })

  useEffect(() => {
    if (!userUUID) {
      setUserUUID(self.crypto.randomUUID());
    }
  }, [setUserUUID, userUUID]);

  return (
    <QueryClientProvider client={queryClient}>
      <I18nProvider i18n={i18n}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Survey />} />
            <Route path="/section/:surveySectionSlug" element={<Survey />} />
            <Route path="/thank-you" element={<ThankYou />} />
          </Routes>
        </BrowserRouter>
      </I18nProvider>
    </QueryClientProvider>
  );
}

export default App;
